<template>
  <div class="jackpot-physical-help-wrapper">
    <div class="mb-md">
      <strong class="text-white text-uppercase">Thanh toán ngay lập tức:</strong> Nhận được khi thu thập được các vé
      Jackpot
    </div>

    <ul style="list-style-type: none">
      <li class="flex-center">
        <span class="flex-center w-100">
          <img class="img-small" src="@/assets/images/mini-ticket.webp" />
          <span style="color: #29ffff; text-transform: uppercase">Mini </span>
        </span>
        <span>Bạn có thể kiếm được tới <strong>$50 USD</strong></span>
      </li>
      <li class="flex-center">
        <span class="flex-center w-100">
          <img class="img-small" src="@/assets/images/minor-ticket.webp" />
          <span style="color: #5ce386; text-transform: uppercase">Minor </span>
        </span>
        <span>Bạn có thể kiếm được tới <strong>$250 USD</strong></span>
      </li>
      <li class="flex-center">
        <span class="flex-center w-100">
          <img class="img-small" src="@/assets/images/major-ticket.webp" />
          <span style="color: #ff6f8b; text-transform: uppercase">Major </span>
        </span>
        <span>Bạn có thể kiếm được tới <strong>$500 USD</strong></span>
      </li>
    </ul>
    <div class="mb-md">
      <strong class="text-white text-uppercase">Rút thăm may mắn:</strong> Giải thưởng được trao trong mỗi lần rút thăm
    </div>

    <div class="prize-header major">
      <div>Phần thưởng Major:</div>
      <div>có 1 giải</div>
    </div>
    <div class="prize-content">
      <div class="prize-content-left">
        <img class="img-small" src="@/assets/images/game-help/jackpot/physical/major-gold.webp" />
        <div>Vàng Doji 999.9 (18.75g)</div>
      </div>
      <div class="prize-content-mid">HOẶC</div>
      <div class="prize-content-right">
        <img class="img-small" src="@/assets/images/game-help/jackpot/physical/major-prize.webp" />
        <div>Iphone 15 Pro max (256gb)</div>
      </div>
    </div>

    <div class="prize-header minor">
      <div>Phần thưởng Minor:</div>
      <div>có 3 giải</div>
    </div>
    <div class="prize-content">
      <div class="prize-content-left">
        <img class="img-small" src="@/assets/images/game-help/jackpot/physical/minor-gold.webp" />
        <div>Vàng Doji 999.9 (3.75g)</div>
      </div>
      <div class="prize-content-mid">HOẶC</div>
      <div class="prize-content-right">
        <img class="img-small" src="@/assets/images/game-help/jackpot/physical/minor-prize.webp" />
        <div>PS5 mỏng</div>
      </div>
    </div>

    <div class="prize-header mini">
      <div>Phần thưởng Mini:</div>
      <div>có 8 giải</div>
    </div>
    <div class="prize-content">
      <div class="prize-content-left">
        <img class="img-small" src="@/assets/images/game-help/jackpot/physical/mini-gold.webp" />
        <div>Vàng Doji 999.9 (1.875g)</div>
      </div>
      <div class="prize-content-mid">HOẶC</div>
      <div class="prize-content-right">
        <img class="img-small" src="@/assets/images/game-help/jackpot/physical/mini-prize.webp" />
        <div>Nintendo Switch (Lite)</div>
      </div>
    </div>

    <div class="h1">Điều khoản và điều kiện</div>
    <ul style="list-style-type: none">
      <li>
        1. Người chiến thắng sẽ nhận được thông báo qua hộp thư email. Vui lòng làm theo hướng dẫn được cung cấp trong
        email để nhận giải thưởng của bạn.
      </li>
      <li>2. Giải thưởng không được nhận trong vòng 45 ngày sẽ bị hủy bỏ.</li>
      <li>3. Thông tin người trúng giải sẽ được bảo mật.</li>
    </ul>
    <BurgerMenu v-if="isMobile" />
  </div>
</template>
<script>
import BurgerMenu from '@/components/burger-menu.vue';
import { isMobile } from 'mobile-device-detect';
export default {
  components: {
    BurgerMenu,
  },
  data: () => {
    return {
      isMobile,
    };
  },
};
</script>
<style lang="scss" scoped>
.jackpot-physical-help-wrapper {
  padding: 16px 24px;
  box-sizing: border-box;
  height: calc(100% - 56px);
  overflow-y: auto;
  font-size: 12px;
  color: #b2d6ea;
}

strong {
  font-weight: 600;
}

.h1 {
  font-size: 14px;
  color: #fff;
  text-transform: uppercase;
  margin: 12px 0;
}

.h2 {
  font-size: 12px;
  color: #b2d6ea;
  text-transform: uppercase;
}

.text-white {
  color: #fff;
}

.flex-center {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.img-small {
  height: 18px;
  margin-right: 8px;
}

.mb-md {
  margin-bottom: 24px;
}

.mr-lg {
  margin-right: 32px;
}

ul {
  padding-inline-start: 0;
}

li {
  min-height: 20px;
  margin: 0.8rem 0;
}

.w-100 {
  width: 100px;
}

.text-uppercase {
  text-transform: uppercase;
}

.prize-header {
  padding: 8px 12px;
  border-radius: 4px;
  text-transform: uppercase;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;

  &.major {
    border: solid 1px rgba(0, 0, 0, 0);
    background-color: #46141e;
    color: #ff6f8b;
  }

  &.minor {
    border: solid 1px rgba(0, 0, 0, 0);
    background-color: #1a4126;
    color: #5ce386;
  }

  &.mini {
    border: solid 1px rgba(0, 0, 0, 0);
    background-color: #0d3c43;
    color: #29ffff;
  }
}

.prize-content {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 16px 0;
  img {
    width: 100%;
    height: auto;
    padding: 0 8px;
    box-sizing: border-box;
  }
  &-left,
  &-right {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    flex: 1 0 30%;
  }
}
</style>
